import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { logout } from "../features/user/redux/signupSlice";
import {
  FileText,
  FolderOpen,
  User,
  LogOut,
  ChevronDown,
  Menu,
  X,
} from "lucide-react";
import "./DashboardHeader.css";
import userStore from "../../zustand/userStore";

export default function DashboardHeader() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.signup);
  const storedUser = user || JSON.parse(localStorage.getItem("userData"));
  const location = useLocation();
  const [profileOpen, setProfileOpen] = useState(false);
  const isDocFormRoute = location.pathname.startsWith("/docFormTestRunNew");
  const dropdownRef = useRef(null);
  const removeUser = userStore.getState().removeUser;
  const [menuOpen, setMenuOpen] = useState(false);
  // const navigate = useNavigate();
  const [openPolicies, setOpenPolicies] = useState(false);
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    removeUser();
    navigate("/home");
  };

  const userName = storedUser?.name || storedUser?.email || "User";
  const initials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const NAV_ITEMS = [
    { label: "About Us", to: "/about-us" },
    { label: "Contact Us", to: "/contact-us" },
  ];

  const POLICY_ITEMS = [
    // { label: "About Us", to: "/about-us" },
    // { label: "Contact Us", to: "/contact-us" },
    { label: "Refund & Cancellation", to: "/refund-cancellation" },
    { label: "Disclaimer", to: "/disclaimer" },
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Terms & Conditions", to: "/terms-conditions" },
    { label: "IPR & Copyright", to: "/ipr-copyright" },
    { label: "FAQs", to: "/contact-us" },
  ];
  return (
    <header className="dash-header">
      <div className="dash-header-inner">
        {/* Logo */}
        <div
          className="dash-header-logo"
          onClick={() => navigate("/dashboard")}
        >
          <img src="/images/docmasterLogo.png" alt="Docmaster" />
        </div>

        {/* Hamburger (mobile only) */}
        <button
          className="dash-hamburger"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>

        {/* Navigation */}
        <nav className={`dash-header-nav ${menuOpen ? "dash-header-nav-open" : ""}`}>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              // style={({ isActive }) => ({
              //   // color: isActive ? "#2563eb" : "#0f172a",
              //   color: isActive ? "black" : "white",
              //   fontWeight: isActive ? 600 : 500,
              //   textDecoration: "none",
              //   padding: "6px 4px",
              // })}
              className={({ isActive }) =>
                `dash-nav-item ${isActive ? "dash-nav-active" : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
          <div
            style={{ position: "relative" }}
            onMouseEnter={() => setOpenPolicies(true)}
            onMouseLeave={() => setOpenPolicies(false)}
          >
            <span
              style={{
                cursor: "pointer",
                // color: "#0f172a",
                color: "rgb(189,212,252)",
                fontWeight: 500,
                padding: "6px 4px",
              }}
            >
              Our Policies ▾
            </span>

            {openPolicies && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                  minWidth: "220px",
                  zIndex: 100,
                }}
              >
                {POLICY_ITEMS.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    style={({ isActive }) => ({
                      display: "block",
                      padding: "10px 14px",
                      color: isActive ? "#2563eb" : "#0f172a",
                      textDecoration: "none",
                      fontWeight: isActive ? 600 : 500,
                    })}
                    onClick={() => {
                      setOpenPolicies(false);
                      setMenuOpen(false);
                    }}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `dash-nav-item ${isActive || isDocFormRoute ? "dash-nav-active" : ""}`
            }
          >
            <FileText size={18} />
            <span>Documents</span>
          </NavLink>
          <NavLink
            to="/myDocForms"
            className={({ isActive }) =>
              `dash-nav-item ${isActive ? "dash-nav-active" : ""}`
            }
          >
            <FolderOpen size={18} />
            <span>My Documents</span>
          </NavLink>
        </nav>

        {/* Profile */}
        <div className="dash-header-profile" ref={dropdownRef}>
          <button
            className="dash-profile-btn"
            onClick={() => setProfileOpen((p) => !p)}
          >
            <div className="dash-avatar">{initials}</div>
            <span className="dash-profile-name">{userName}</span>
            <ChevronDown
              size={16}
              className={`dash-chevron ${profileOpen ? "dash-chevron-open" : ""}`}
            />
          </button>

          {profileOpen && (
            <div className="dash-profile-dropdown">
              <div className="dash-dropdown-header">
                <div className="dash-avatar dash-avatar-lg">{initials}</div>
                <div>
                  <p className="dash-dropdown-name">{userName}</p>
                  <p className="dash-dropdown-email">
                    {storedUser?.email || ""}
                  </p>
                </div>
              </div>
              <div className="dash-dropdown-divider" />
              <button
                className="dash-dropdown-item"
                onClick={() => {
                  setProfileOpen(false);
                }}
              >
                <User size={16} />
                <span>Profile</span>
              </button>
              <button
                className="dash-dropdown-item dash-dropdown-logout"
                onClick={handleLogout}
              >
                <LogOut size={16} />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
